import { createClient } from '@supabase/supabase-js';

// Load variables from .env file (Vite standard)
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("Supabase URL or Key missing. Database features will fail. Check your .env file.");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
